// extracted by mini-css-extract-plugin
export default {"wrapper":"NewDesignBasicPage_wrapper__Zuolo","innerWrapper":"NewDesignBasicPage_innerWrapper__chZ4k","content":"NewDesignBasicPage_content__0qGck"};